import { amortize } from '../../../../utils/amortisation'

interface CalculateInterestOnlyMortgageArgs {
  mortgageBalance: number
  interestRate: number
  years: number
  months: number
}

interface InterestOnlyMortgageResults {
  totalInterest: number
  monthlyPayment: number
}

export const calculateInterestOnlyMortgage = ({
  mortgageBalance,
  interestRate,
  years,
  months,
}: CalculateInterestOnlyMortgageArgs): InterestOnlyMortgageResults => {
  // take mortgage amount, apply interest, take interest and divide by total number of months
  // that gives you monthly payment

  if (interestRate === 0 || mortgageBalance === 0 || years === 0) {
    return {
      totalInterest: 0,
      monthlyPayment: 0,
    }
  }

  const totalMonths = years * 12 + months
  const interest = mortgageBalance * (interestRate / 100) * (totalMonths / 12)

  return {
    totalInterest: Math.round(interest),
    monthlyPayment: Math.round(interest / totalMonths),
  }
}

interface CalculateRepaymentMortgageArgs {
  mortgageBalance: number
  interestRate: number
  years: number
  months: number
}

export const calculateRepaymentMortgage = ({
  mortgageBalance,
  interestRate,
  years,
  months,
}: CalculateRepaymentMortgageArgs) => {
  const term = years * 12 + months

  const { payment } = amortize({
    amount: mortgageBalance,
    rate: interestRate,
    totalTerm: term,
    amortizeTerm: term,
  }) as { payment: number }

  if (!payment) {
    return 0
  }

  return Math.round(payment)
}
